import { Dispatch, forwardRef, SetStateAction, SyntheticEvent } from 'react';
import { Snackbar as MuiSnackbar } from '@mui/material';
import MuiAlert, { AlertColor, AlertProps } from '@mui/material/Alert';
import Stack from '@mui/material/Stack';

const Alert = forwardRef<HTMLDivElement, AlertProps>(function Alert(
	props,
	ref
) {
	return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

const Snackbar = ({
	message,
	open,
	setOpen,
	severity = 'success',
}: {
	message: string;
	severity?: AlertColor;
	open: boolean;
	setOpen: Dispatch<SetStateAction<boolean>>;
}) => {
	const handleClose = (event?: SyntheticEvent | Event, reason?: string) => {
		if (reason === 'clickaway') {
			return;
		}
		setOpen(false);
	};

	return (
		<Stack spacing={2} sx={{ width: '100%' }}>
			<MuiSnackbar open={open} autoHideDuration={3000} onClose={handleClose}>
				<Alert onClose={handleClose} severity={severity} sx={{ width: '100%' }}>
					{message}
				</Alert>
			</MuiSnackbar>
		</Stack>
	);
};
export default Snackbar;
